import { LoadingPage } from "@hortis/ui/loading";
import { useNavigate } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useEffect } from "react";

interface Props {
  url: string;
}

export const Redirect = ({ url }: Props): ReactElement => {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({ to: url });
  }, [navigate, url]);
  return <LoadingPage />;
};
